<template>
  <div class="home">
    <div class="banner" :style="{backgroundImage:ready?'url('+data.img_pc+')':''}">&nbsp;</div>
    <div class="content">
      <transition name="el-fade-in-linear">
        <div v-show="ready">
          <div class="w1">{{data.w1}}</div>
          <div class="w2">{{data.w2}}<span class="w3">{{data.w3}}</span></div>
          <div class="w6">{{data.w6}}<span class="w7">{{data.w7}}</span></div>
          <div class="w4">{{data.w4}}<em style="font-weight: bold;color: red;margin: 0 10px">-</em><span class="w5">{{data.w5}}</span></div>
        </div>
      </transition>
      <div class="not_ready" v-if="!ready">loading…</div>
    </div>
    <div class="main">
      <div v-if="ready">
        <div class="classify">
          <el-row>
            <button type="button" @click="changeClassify(index)" :class="['btn_default',{btn_active:index===active}]" v-for="(item,index) in classifyList" :key="index">{{item.name}}</button>
          </el-row>
        </div>
        <div class="works">
          <el-row>
            <el-col class="works-item" :span="item.position===2?8:4" v-for="(item,i) in worksList" :key="'w'+i">
              <!--<img :src="item.cover" style="max-width: 100%;height: 180px;" @click="toDetail(item.id)"/>-->
              <el-image :src="item.cover" fit="fill" style="width: 100%;height: 190px;" @click="showDetail(item.id)">
                <div slot="placeholder">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
            </el-col>
          </el-row>
          <div class="page" v-if="total>this.form.limit">
            <el-pagination
                    layout="prev, pager, next"
                    :page-size="this.form.limit"
                    @current-change="changePage"
                    :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="not_ready" v-if="!ready">loading…</div>
    </div>
    <!--详情框架-->
    <el-drawer
            class="works_box"
            :visible.sync="show"
            direction="btt">
      <div style="width: 1200px;min-height: 200px;margin: auto;padding-bottom: 2rem;">
        <el-row v-if="detail" v-viewer="options">
          <el-col class="image_box" :span="4" v-for="(item,index) in detail.thumbs" :key="index">
            <el-image :src="item"
                      @contextmenu.prevent
                      :data-source="detail.images[index]"
                      fit="fill"
                      style="width: 100%;height: 190px;">
              <div slot="placeholder">
                加载中<span class="dot">...</span>
              </div>
            </el-image>
          </el-col>
        </el-row>
      </div>
      <div slot="title">
        <div style="width:1200px;margin: auto;">
          <div v-if="detail" class="title">
            {{detail.title}}&nbsp;&nbsp;
            <span class="classifyName">{{detail.classifyName}}</span>
            <span class="tip">*点击图片查看大图</span>
            <div class="describe" v-if="detail.describe">{{detail.describe}}</div>
          </div>
          <div v-else style="text-align: center;font-size: 1rem;">
            <i class="el-icon-loading"></i> 加载中…
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
  import {getWorksData,getWorksList as getList,getWorksDetail} from "../request/service";
  import 'viewerjs/dist/viewer.css'
  import Viewer from 'v-viewer'
  import Vue from 'vue'
  Vue.use(Viewer,{
    // debug: true,
    defaultOptions: {
      zIndex: 9999
    }
  });
  // @ is an alias to /src
export default {
  name: 'Works',
  data(){
    return{
      options:{
        toolbar: true,
        url: 'data-source',
        title:false
      },
      ready:false,
      active:0,
      classifyList:[{id:0,name:'全部 / All'}],
      worksList:[],
      total:0,
      data:{
        w1:'',
        w2:'',
        w3:'',
        w4:'',
        w5:'',
        w6:'',
        w7:'',
        img_pc:'',
      },
      form:{
        type:0,
        page:1,
        limit:10
      },
      show:false,
      detail:null,
    }
  },
  methods:{
    changeClassify(index){
      this.active=index
      this.form.type=this.classifyList[index].id
      this.form.page=1
      this.worksList=[]
      this.getWorksList()
      this.$router.push({name:'Works',query:{id:this.form.type}})
    },
    getWorksList(){
      // this.form.page++
      const that=this
      getList(this.form).then(res=>{
        that.total=res.data.total
          that.worksList=res.data.list
        // if(that.form.page<2){
        //   that.worksList=res.data.list
        // }else{
        //   that.worksList=that.worksList.concat(res.data.list)
        // }
      })
    },
    getDetail(id){
      const that=this
      getWorksDetail({id:id}).then(res=>{
        that.detail=res.data
      })
    },
    changePage(p){
      this.form.page=p
      this.getWorksList()
    },
    showDetail(id){
      this.show=true
      if(this.detail&&this.detail.id===id){
        return false
      }
      this.detail=null
      this.getDetail(id)
    },
    previewImage(index){

    }
  },
  created() {
    let id=this.$route.query.id?this.$route.query.id:0;
    if(id!==0){
      this.form.type=this.$route.query.id;
      this.form.page=0;
      this.getWorksList()
    }
    const that=this
    getWorksData().then(res=>{
      that.data=res.data.config
      that.classifyList=that.classifyList.concat(res.data.classifyList)
      that.total=res.data.total
      if(id===0){
        that.worksList=res.data.worksList
      }else{
        for(let i=0;i<that.classifyList.length;i++){
          if(parseFloat(id)===that.classifyList[i].id){
            that.active=i
            break
          }
        }
      }
      that.ready=true
    })
  }
}
</script>

<style scoped>
  .home{
    width: 96%;
    margin: 0 2%;
    /*background: #fff;*/
    position: relative;
    padding-top: 60px;
  }
  .home .banner{
    height: 400px;
    background: #181818;
    background-repeat: no-repeat;
    background-position: center top;
  }
  .home .content{
    width: 1080px;
    margin: -440px auto auto auto;
    height: 200px;
    background: #242424;
    color: #cccccc;
    padding: 3rem 60px 1rem 60px;
    text-align: left;
  }
  .home .content .w1{
    font-size: .8rem;
    margin-bottom: 3rem;
  }
  .home .content .w2{
    font-size: 3rem;
    font-weight: bold;
    margin-bottom: 1rem;
    color: #ffffff;
  }
  .home .content .w3{
    font-weight: normal;
    margin-left: 2rem;
    font-size: 2rem;
    color: #cccccc;
  }
  .home .content .w7{
    margin-left: 1rem;
  }
  .home .content .w4{
    text-align: right;
    color: #ffffff;
  }
  .home .content .w5{
    color: #cccccc;
  }
  .home .main{
    width: 1200px;
    margin:220px auto 100px auto;
  }
  .home .main .classify{
    text-align: left;
    min-height: 51px;
  }
  .home .main .works{
    min-height: 242px;
  }
  .btn_default{
    border-radius: 20px;
    padding: 8px 20px;
    border:1px solid #ff946f;
    margin-bottom: 1rem;
    margin-right: 1.3rem;
    outline:none;
    cursor:pointer;
    color: #ffffff;
    background: transparent;
  }
  .btn_active{
    background:linear-gradient(to right, #ff656d, #ffbe71) ;
  }
  .btn_default:hover{
    background:linear-gradient(to right, #ff656d, #ffbe71) ;
  }
  .works-item{
    padding: 5px;
    cursor: pointer;
  }
  .works-item:hover{
    background: #545454;
  }
  .works-item .item{
    /*background: #999999;*/
    /*height: 190px;*/
  }
  .page>>>.el-pagination,.page>>>.btn-prev,.page>>>.btn-next,.page>>>.btn-quicknext{
    color: #cccccc;
  }
  .page>>>button{
    background-color: #1d1d1d !important;
  }
  .page>>>button:disabled{
    color: #666666;
  }
  .page>>>li{
    background-color: #1d1d1d !important;
  }
  .works_box>>>.el-drawer{
    height: auto !important;
    text-align: left;
    background: #242424;
    max-height: 90%;
    overflow-y: auto;
  }
  .works_box .image_box{
    padding: 5px;
    cursor: pointer;
  }
  .works_box .image_box:hover{
    background: #545454;
  }
  .works_box .image_box img{

  }
  .works_box .title{
    font-size: 1.2rem;
    padding-left: 1rem;
    color: #ffffff;
  }
  .works_box .describe{
    padding-top: 1rem;
    color: #cccccc;
    font-size: .8rem;
  }
  .works_box .classifyName{
    background:#cccccc ;
    color: #242424;
    padding: 4px 10px;
    border-radius: 0 12px 12px 0;
    font-size: .8rem;
  }
  .works_box .tip{
    padding-left:20px;
    font-size:.8rem;
    color: #cccccc;
  }
  .works_box>>>.el-image-viewer__close{
    color: #cccccc;
  }
</style>
<style>
  .viewer-backdrop{
    background-color: rgba(0,0,0,.7) !important;
  }
</style>
